/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Tomorrow_Style_CodeInputs */

const en_field_tomorrow_style_code = /** @type {(inputs: Field_Tomorrow_Style_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow style code`)
};

/**
* | output |
* | --- |
* | "Tomorrow style code" |
*
* @param {Field_Tomorrow_Style_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_tomorrow_style_code = /** @type {((inputs?: Field_Tomorrow_Style_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Tomorrow_Style_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_tomorrow_style_code(inputs)
});